var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpansionWidgetStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 70,
    viewBox: "0 0 156 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 7.58172 3.58172 4 8 4H144C148.418 4 152 7.58172 152 12V62C152 66.4183 148.418 70 144 70H8C3.58172 70 0 66.4183 0 62V12Z",
    fill: "#EEEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 7.85786 3.85786 4.5 8 4.5H144C148.142 4.5 151.5 7.85786 151.5 12V62C151.5 66.1421 148.142 69.5 144 69.5H8C3.85786 69.5 0.5 66.1421 0.5 62V12Z",
    stroke: "black",
    strokeOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C5 9.89543 5.89543 9 7 9H27C28.1046 9 29 9.89543 29 11V17C29 18.1046 28.1046 19 27 19H7C5.89543 19 5 18.1046 5 17V11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 23.8954 5.89543 23 7 23H68C69.1046 23 70 23.8954 70 25V63C70 64.1046 69.1046 65 68 65H7C5.89543 65 5 64.1046 5 63V25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25C82 23.8954 82.8954 23 84 23H144C145.105 23 146 23.8954 146 25V63C146 64.1046 145.105 65 144 65H84C82.8954 65 82 64.1046 82 63V25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 10C75 9.44771 75.4477 9 76 9C76.5523 9 77 9.44772 77 10V64C77 64.5523 76.5523 65 76 65C75.4477 65 75 64.5523 75 64V10Z",
    fill: "black",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpansionWidgetStyle);
export default __webpack_public_path__ + "static/media/icon-expansion-widget-style.386144ee6cf146ef1337fe9ffb0a9cf2.svg";
export { ForwardRef as ReactComponent };